import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UserAuthenticationService } from "../../services/shared";

@Component({
  selector: "home-component",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: require("./home.component.html"),
  styles: [require("./home.component.less").toString()]
})

export class HomeComponent implements OnInit {
  localState = { value: "" };
  activeTabId: number = 2;
  hasAppViewPerm = true;
  activeTasks = { tasks: [], totalTasks: 3 };
  activeMessages = { messages: [], totalMessages: 2 };

  constructor(public userAuthService: UserAuthenticationService, private routeProvider: Router, private cecActivatedRoute: ActivatedRoute) { }

  public ngOnInit() {
    this.routeProvider.navigate(["/myhome"]);
  }
  public setCurrentTab(tabIndex: number): void {
      this.activeTabId = tabIndex;
      //if(this.userAuthService.isAuthenticated)
  };

}


// WEBPACK FOOTER //
// ./src/app/components/home/home.component.ts